/* Catherine Gee — "Add the set": adds every suggested piece of one print in the sizes shown, in one request,
   then asks Prestige's drawer to re-render (the panel then disappears because the set is in the bag). */
(function () {
  if (window.__cgSetBound) return; window.__cgSetBound = true;
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-cg-set-all]"); if (!btn) return;
    e.preventDefault();
    const set = btn.closest("[data-cg-set]"); if (!set || btn.getAttribute("aria-busy") === "true") return;
    const items = [...set.querySelectorAll("[data-cg-set-variant]")].map((el) => ({ id: +el.value, quantity: 1, properties: { _upsell: "complete-the-set" } })).filter((i) => i.id);
    if (!items.length) return;
    btn.setAttribute("aria-busy", "true");
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    try {
      const r = await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || "/"}cart/add.js`, { method: "POST", headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: JSON.stringify({ items }) });
      if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || "Could not add the set"); }
    } catch (err) {
      btn.removeAttribute("aria-busy"); btn.textContent = err.message; return;
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    }
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  });
})();

/* Catherine Gee — "Complete the set" pop-up after Add to bag (product pages).
   1. On a product page, prefetch the pop-up section once: does this product's print have other pieces in stock?
   2. When the main Add to bag succeeds for such a product, keep Prestige's drawer closed (capture cart:change and
      re-label its baseEvent), fetch the pop-up for the added variant (sizes default to it) and open it.
   3. Adds from the pop-up go straight to /cart/add.js (tagged _upsell = complete-the-set-modal) and refresh the drawer.
   4. Closing the pop-up (X, backdrop, Esc, "Continue to bag", or after "Add the set") opens the drawer as usual.
   Adds from the drawer's own set panel never open the pop-up. Products without a set keep the normal drawer flow. */
(function () {
  if (window.__cgSetModalBound) return; window.__cgSetModalBound = true;
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const money = (cents) => "$" + Math.round(cents / 100).toLocaleString("en-US");
  const drawer = () => document.querySelector("cart-drawer");
  const hasSet = {};
  let pending = null;

  const handleFromPath = () => { const m = location.pathname.match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null; };
  const sectionUrl = (handle, variant) => `${ROOT}products/${encodeURIComponent(handle)}?${variant ? "variant=" + variant + "&" : ""}section_id=cg-set-modal`;
  const fetchModal = async (handle, variant, ms = 3500) => {
    const ctl = new AbortController(); const t = setTimeout(() => ctl.abort(), ms);
    try { const r = await fetch(sectionUrl(handle, variant), { signal: ctl.signal, credentials: "same-origin" }); return r.ok ? await r.text() : ""; }
    catch (e) { return ""; } finally { clearTimeout(t); }
  };

  // 1. prefetch on product pages
  const pdp = handleFromPath();
  if (pdp && (!window.themeVariables || window.themeVariables.settings.pageType === "product")) {
    fetchModal(pdp).then((h) => { hasSet[pdp] = h.includes("data-cg-setm"); });
  }

  // 2. intercept the main Add to bag
  document.addEventListener("variant:add", (e) => {
    const t = e.target;
    if (t && t.closest && t.closest("[data-cg-set], .cg-setm")) return;   // adds from the set UIs themselves
    const it = (e.detail && e.detail.items || [])[0];
    if (!it || !hasSet[it.handle]) return;
    pending = it;
  }, true);
  window.addEventListener("cart:change", (e) => {
    if (!pending || !e.detail || e.detail.baseEvent !== "variant:add") return;
    e.detail.baseEvent = "cg-set-modal";   // Prestige opens the drawer only for baseEvent "variant:add"
    const it = pending; pending = null;
    openModal(it);
  }, true);

  const dialog = () => {
    let d = document.getElementById("cg-set-modal");
    if (d) return d;
    d = document.createElement("dialog"); d.id = "cg-set-modal"; d.className = "cg-setm"; d.setAttribute("aria-label", "Complete the set");
    document.body.appendChild(d);
    d.addEventListener("close", () => { const dr = drawer(); if (dr && dr.show) dr.show(); });
    d.addEventListener("click", (e) => {
      if (e.target === d) { d.close(); return; }
      if (e.target.closest("[data-cg-setm-close]")) { d.close(); return; }
      const one = e.target.closest("[data-cg-setm-add]"); if (one) { addPieces(d, [one.closest("[data-cg-setm-piece]")], one); return; }
      const all = e.target.closest("[data-cg-setm-all]"); if (all) { addPieces(d, [...d.querySelectorAll("[data-cg-setm-piece]:not(.is-added)")], all, true); }
    });
    d.addEventListener("change", (e) => {
      const sel = e.target.closest("select[data-cg-setm-variant]"); if (!sel) return;
      const piece = sel.closest("[data-cg-setm-piece]"); const opt = sel.selectedOptions[0];
      if (opt && opt.dataset.price) { piece.dataset.price = opt.dataset.price; piece.querySelector(".cg-setm__price").textContent = money(+opt.dataset.price); }
      updateTotal(d);
    });
    return d;
  };
  const updateTotal = (d) => {
    const rest = [...d.querySelectorAll("[data-cg-setm-piece]:not(.is-added)")];
    const all = d.querySelector("[data-cg-setm-all]");
    if (all) {
      if (rest.length < 2) all.remove();
      else { const tot = rest.reduce((s, p) => s + (+p.dataset.price || 0), 0); const el = all.querySelector("[data-cg-setm-total]"); if (el) el.textContent = money(tot); }
    }
    if (!rest.length) { const c = d.querySelector(".cg-setm__continue"); if (c) { c.textContent = "View bag"; c.classList.add("is-primary"); } }
  };
  const addPieces = async (d, pieces, btn, closeAfter) => {
    pieces = pieces.filter(Boolean); if (!pieces.length || btn.getAttribute("aria-busy") === "true") return;
    const items = pieces.map((p) => ({ id: +p.querySelector("[data-cg-setm-variant]").value, quantity: 1, properties: { _upsell: "complete-the-set-modal" } }));
    btn.setAttribute("aria-busy", "true");
    try {
      const r = await fetch(`${ROOT}cart/add.js`, { method: "POST", headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: JSON.stringify({ items }) });
      if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || "Could not add"); }
      pieces.forEach((p) => { p.classList.add("is-added"); const b = p.querySelector("[data-cg-setm-add]"); if (b) { b.textContent = "Added"; b.disabled = true; } p.querySelectorAll("select").forEach((s) => (s.disabled = true)); });
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      updateTotal(d);
      if (closeAfter) setTimeout(() => d.close(), 350);
    } catch (err) {
      const note = d.querySelector(".cg-setm__err") || Object.assign(document.createElement("p"), { className: "cg-setm__err" });
      note.textContent = err.message; d.querySelector(".cg-setm__foot").before(note);
    } finally { btn.removeAttribute("aria-busy"); }
  };
  const openModal = async (it) => {
    const html = await fetchModal(it.handle, it.variant_id);
    const tmp = document.createElement("div"); tmp.innerHTML = html;
    const inner = tmp.querySelector("[data-cg-setm]");
    if (!inner) { const dr = drawer(); if (dr && dr.show) dr.show(); return; }
    const d = dialog(); d.replaceChildren(inner);
    if (!d.open) d.showModal();
    inner.setAttribute("tabindex", "-1"); inner.focus({ preventScroll: true });   // focus inside the dialog without lighting up a button
  };
})();
